import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { DatePicker } from "components/support";
import Moment from "moment";

class PaymentsReportFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: props.filters,
      changedFilter: false
    };
  }

  handleChange = ({ startDate, endDate, paymentType }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    if (paymentType) {
      return onChange({ paymentType });
    }

    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        ...options
      }
    }));
  };

  handleDatePicked = () => {
    const { onChange } = this.props;
    this.setState({ changedFilter: !this.state.changedFilter }, () =>
      onChange(this.state.filters)
    );
  };

  render() {
    const { dateFrom, dateTo } = this.state.filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Typography type="headline">Filtro</Typography>
        <Row>
          <Col xs={12}>
            <DatePicker
              multiple
              label="Período"
              modal
              fullWidth
              startDate={dateFrom}
              endDate={dateTo}
              onChange={this.handleChange}
              onClose={this.handleDatePicked}
            />
          </Col>
        </Row>
      </Paper>
    );
  }
}

export default PaymentsReportFilter;



// WEBPACK FOOTER //
// ./src/components/app/management/payments-report/filter/index.jsx